import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { EEstateType } from '../../../packages/api-models/common/json_query';

export const selectEstateType = createSelector(
  selectJsonQuery,
  jsonQuery => getTermsValue('estate_type')(jsonQuery) as EEstateType[] | null,
);
